import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-epod',
    templateUrl: './epod.component.html',
    styleUrls: ['./epod.component.scss'],
    standalone: false
})
export class EpodComponent implements OnInit {
  accessCode: string = '';
  loading: boolean = false;
  error: string = '';
  success: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      this.accessCode = queryParams['a'] || '';
      
      if (this.accessCode) {
        this.downloadEpodDocument();
      } else {
        this.error = 'Access code is required';
        this.showSnackBar('Access code is required', 'error');
      }
    });
  }

  downloadEpodDocument(): void {
    this.loading = true;
    this.error = '';
    this.success = false;

    const url = `${environment.conciergeUrl}/concierge/api/v1/epod-document/${this.accessCode}`;

    this.http.get<{ documentUrl: string }>(url).subscribe({
      next: (response: any) => {
        this.loading = false;
        
        const documentUrl = response?.documentUrl;
        
        if (documentUrl) {
          this.success = true;
          
          // Download the document
          this.downloadFile(documentUrl);
          
          // Also open in new tab for viewing
          window.open(documentUrl, '_blank');
          
          this.showSnackBar('Document downloaded and opened', 'success');
        } else {
          this.error = 'Document URL not found in response';
          this.showSnackBar('Document URL not found', 'error');
        }
      },
      error: (error) => {
        this.loading = false;
        this.success = false;
        this.error = 'Failed to fetch document';
        console.error('Download error:', error);
        
        this.showSnackBar('Failed to fetch document', 'error');
      }
    });
  }

  private downloadFile(url: string): void {
    // Extract filename from URL or use default
    let filename = 'epod-document.pdf';
    try {
      const urlPath = new URL(url).pathname;
      const urlFilename = urlPath.split('/').pop();
      if (urlFilename && urlFilename.includes('.')) {
        filename = urlFilename;
      }
    } catch (e) {
      // Use default filename if URL parsing fails
    }

    // Create a hidden link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private showSnackBar(message: string, type: 'success' | 'error'): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: type === 'success' ? ['success-snackbar'] : ['error-snackbar']
    });
  }
}

